import { FormControl, FormValidationRuleWithState } from "../types";
import { evaluates_as_hiddenV2 } from "../conditional-logic";

import parsePhoneNumber, { CountryCode } from "libphonenumber-js";

const ERROR_MESSAGE =
    "You've already used this value, it cannot be duplicated in this field.";

const getValue = (o: any) =>
    typeof o === "object" && "value" in o ? o.value : o;

const checkEqual = (obj1: any, obj2: any) => {
    //todo it maybe need deep comparsion
    if (typeof obj1 === "object" && typeof obj2 === "object") {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) {
            return false;
        }
        let key: keyof typeof obj1;
        let index = 0;
        for (key in obj1) {
            if (typeof obj1[key] === "object") {
                if (
                    JSON.stringify(obj1[key]) !==
                    JSON.stringify(obj2[Object.keys(obj2)[index]])
                ) {
                    return false;
                }
            } else if (obj1[key] !== obj2[Object.keys(obj2)[index]]) {
                return false;
            }
            index++;
        }
        return true;
    }
    return false;
};

export const validateMultiInput: any = (
    c: FormControl,
    sourceValue: any,
    targetValue: any
) => {
    if (
        c.type === "email" &&
        typeof sourceValue === "object" &&
        typeof targetValue === "string"
    ) {
        /** Email in confirm mode */
        return validateSingleInput(
            c,
            Object.values(sourceValue)[0],
            targetValue
        );
    }
    return [
        !checkEqual(sourceValue, targetValue),
        c.errorMessage || ERROR_MESSAGE
    ];
};

export const validateSingleInput: any = (
    c: FormControl,
    sourceValue: any,
    targetValue: any
) => {
    if (
        c.type === "boi_phone" &&
        sourceValue &&
        sourceValue.length > 0 &&
        targetValue &&
        targetValue.length > 0
    ) {
        return validatePhone(c, sourceValue[0], targetValue[0], sourceValue[1]);
    }
    if (c.type === "phone") {
        return validatePhone(c, sourceValue, targetValue);
    }
    // Case insensitive validation for the email field
    if (c.type === "email") {
        return [
            targetValue === undefined ||
            sourceValue.toLowerCase() !== targetValue.toLowerCase(),
            c.errorMessage || ERROR_MESSAGE
        ];
    }
    return [sourceValue !== targetValue, c.errorMessage || ERROR_MESSAGE];
};

const validatePhone: any = (
    c: FormControl,
    sourceValue: any,
    targetValue: any,
    countryCode?: CountryCode
) => {
    const targetPhoneNumber = parsePhoneNumber(targetValue, countryCode || "IE");
    if (typeof targetPhoneNumber !== "undefined") {
        const country = targetPhoneNumber.country;
        const sourcePhoneNumber = parsePhoneNumber(sourceValue, country);
        if (typeof sourcePhoneNumber !== "undefined") {
            return [
                sourcePhoneNumber.formatInternational() !==
                    targetPhoneNumber.formatInternational(),
                c.errorMessage || ERROR_MESSAGE
            ];
        }
    }
    return [true, ''];
};

const sameValue: FormValidationRuleWithState = (c, v, s) => {
    if (c.field_not_same_validation && c.field_not_same_source && v) {
        const targetName = "input_" + c.field_not_same_source;
        const targetValue = getValue(s.values[targetName]);
        const targetControl = (s.controls as React.ReactElement[]).find(control =>
            control.props.name === targetName);
        const page = (s.controls as React.ReactElement[]).find(control =>
            control.props.type === "page" && !!targetControl && control.props.pageNumber === targetControl.props.pageNumber);
        const isPageHidden = !!page && evaluates_as_hiddenV2(page.props.conditionalLogic, s);
        const isControlHidden = !targetControl || evaluates_as_hiddenV2(targetControl.props.conditionalLogic, s);
        const [valid, message] = c.inputs
            ? validateMultiInput(c, v, targetValue)
            : validateSingleInput(c, v, targetValue);
        
        if (!valid && !isPageHidden && !isControlHidden) {
            return [valid, message];
        }
    }
    return [true, ""];
};

export default sameValue;